import React, { useMemo } from 'react';
import './DetailsPage.scss';
import { Icon, Card } from '@design-system/index';
import { MembersListLine, Warning } from '@assets/images/icons';
import { DetailsTabs } from './DetailsTabs';
import { Tabs } from '@components/Tabs/Tabs';
import { useParams } from 'react-router-dom';
import { useDetailsPageVM } from './useDetailsPageVM';

export default function DetailsPage() {

    const { tab } = useParams();
    const tabIndex = DetailsTabs(() => {}).findIndex(t => t.path === tab);

    const { member } = useDetailsPageVM();

    const headerTitle = useMemo(() => {
        if (!member) return "Fiche adhérent";
        return <div style={{ display: 'flex', gap: 5, alignItems: 'center'}}>
            {!member.contributionUpToDate && <Icon icon={<Warning />} size={18} color="error" />}
            {member.cosemNumber + ' - ' + member.personalInformation.firstname + ' ' + member.personalInformation.lastname}
        </div>;
    }, [member]);

    return (
        <div className="details-member-container">
            <Card headerType='full' showBack backTo="/members-management/members" headerTitle={headerTitle} headerIcon={<Icon icon={<MembersListLine />} size={20} color="primary" />}>
                <Tabs orientation="horizontal" tabs={DetailsTabs} defaultActiveTab={tabIndex === -1 ? 0 : tabIndex} />
            </Card>
        </div>
    );
};
